import type { FileUploadController } from "@msuite/ui/file-upload";
import { createContext, useContext } from "react";

/** Interface */
interface ICalculationEditorContext {
	handleOnSubmit: (withTrigger?: boolean) => void;
	isSubmitting: boolean;
	setIsSubmitting: (isSubmitting: boolean) => void;
	fileUploadController: FileUploadController;
	calculationId: string;
	/** Whether the calculation is locked, which renders the form read-only and stops saving. */
	isLocked: boolean;
}

/** Context */
export const CalculationEditorContext = createContext<ICalculationEditorContext>(
	{} as ICalculationEditorContext,
);

/** Hooks */
export function useCalculationEditorContext() {
	return useContext(CalculationEditorContext);
}
